import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation, Autoplay } from 'swiper/modules'
import { getCasinoGameImgIdentifier } from '../../util/gaming'
import Image from "next/legacy/image"
import { CmsCompetitionDTO } from '@arland-bmnext/webapps-api-data'

export const CasinoSlider = ({
  casinoGames,
  onCasinoGameClick,
  casinoSliderAutoPlayDelay,
}: {
  casinoGames: CmsCompetitionDTO[]
  onCasinoGameClick: (gameId: number, gameName: string) => void
  casinoSliderAutoPlayDelay: number
}) => {
  return (
    <div className={`casino-slider flex relative w-full px-2 md:px-4 aspect-[4/1]`}>
      <Swiper
        className="casino-slider-swiper w-full"
        modules={[Pagination, Navigation, Autoplay]}
        pagination={{
          clickable: true,
          horizontalClass: casinoGames?.length > 1 ? 'swiper-horizontal-pagination' : 'hidden',
          bulletClass: 'swiper-horizontal-pagination-bullet',
          bulletActiveClass: 'swiper-horizontal-pagination-bullet-active',
        }}
        grabCursor
        navigation
        autoplay={{
          delay: casinoSliderAutoPlayDelay ? casinoSliderAutoPlayDelay * 1000 : 3000,
        }}
      >
        {casinoGames?.map((casinoGame) => {
          const imgIdentifier = getCasinoGameImgIdentifier(casinoGame, '4x1')

          return (
            <SwiperSlide
              key={casinoGame.id}
              onClick={() => onCasinoGameClick(casinoGame.id, casinoGame.name)}
              className="casino-slider-swiper-slide rounded-md overflow-hidden cursor-pointer"
            >
              {imgIdentifier ? (
                <Image src={imgIdentifier} layout="fill" objectFit="cover" alt={casinoGame.name} />
              ) : (
                <div className="flex justify-center items-center h-full w-full bg-gray-500 text-white">
                  {casinoGame.name}
                </div>
              )}
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}
